export const getResource = (resource, id) => {
  const nodeObject = resource.filter(el => el.node ? el.node.frontmatter.title === id : el.frontmatter.title === id)[0];
  return nodeObject && nodeObject.node ? nodeObject.node.frontmatter : nodeObject.frontmatter;
}
